/**
 * Reducer to handle SIGN_IN action
 **/
export function isSignInReducer(state = false, action) {
	switch (action.type) {
		case 'SIGN_IN':
			return action.isSignIn;
		default:
			return state;
	}
}

